import React, { useCallback } from "react";
import { microCopy } from "@bmi-digital/dxb-microcopies";
import TextField from "@bmi-digital/components/text-field";
import { useSiteContext } from "../Site";
import { validateRegistrationEmail as validateRegistrationEmailStructure } from "../../utils/emailUtils";
import { FieldNames } from "./types";
import type { EmailFieldProps } from "./types";

const EmailField = ({
  alreadyExists,
  needsVerification,
  lastBrokenEmail,
  value,
  setValue
}: EmailFieldProps) => {
  const { getMicroCopy } = useSiteContext();

  const handleValidateEmail = useCallback(
    (email: string | undefined) => {
      const invalidEmailErrorText = getMicroCopy(
        microCopy.ERRORS_EMAIL_INVALID
      );
      const isBrokenEmail = email && email === lastBrokenEmail;

      if ((alreadyExists || needsVerification) && isBrokenEmail) {
        return invalidEmailErrorText;
      }

      return validateRegistrationEmailStructure(invalidEmailErrorText, email);
    },
    [getMicroCopy, alreadyExists, needsVerification, lastBrokenEmail]
  );

  const handleChange = useCallback(
    (newValue: string | undefined) => {
      setValue(newValue);
    },
    [setValue]
  );

  return (
    <TextField
      id={FieldNames.email}
      name={FieldNames.email}
      data-testid="embedded-registration-form-email-field"
      type="email"
      label={getMicroCopy(microCopy.REGISTRATION_FORM_EMAIL_FIELD_LABEL)}
      variant="hybrid"
      isRequired
      fieldIsRequiredError={getMicroCopy(
        microCopy.VALIDATION_ERRORS_FIELD_REQUIRED
      )}
      fullWidth
      getValidationError={handleValidateEmail}
      onChange={handleChange}
      value={value}
    />
  );
};

export default EmailField;
